export const bobbyCalvesProfileRoute: string = "bobby-calves-profile";
export const bobbyCalvesCalendarRoute: string = "bobby-calves-calendar";